
import React from "react";
import { BrowserRouter as Router, Routes, Route, useRoutes } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";
import 'react-circular-progressbar/dist/styles.css';

import { Provider } from "react-redux";
import store from "./store";
import { WagmiConfig, createConfig, configureChains } from "wagmi";
import {
  bsc,
  bscTestnet,
  polygon,
  polygonMumbai,
  sepolia,
  mainnet
} from "viem/chains";
import { publicProvider } from "wagmi/providers/public";
import { MetaMaskConnector } from "wagmi/connectors/metaMask";
import { WalletConnectConnector } from "wagmi/connectors/walletConnect";

import Home from './pages/home.js';
import Dashboard from "./pages/dashboard.js";
import DashboardCheck from "./pages/dashboardCheck"
import JoinNow from "./pages/join_now.js";
import Distribute from "./pages/Distribute.js";
import UpdateAddress from "./pages/UpdateAddress.js";
import RegistrationNotification from "./pages/collapse.js"

const RPC_URLS = {
  56: "https://bsc-dataseed.binance.org/",
  97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
};

const { chains, publicClient, webSocketPublicClient } = configureChains(
  [bsc, bscTestnet],
  [
    jsonRpcProvider({
      rpc: (chain) => {
        return { http: RPC_URLS[chain.id] || "" };
      },
    }),
  ],
  [publicProvider()]
);

// Set up wagmi config
const config = createConfig({
  autoConnect: true,
  connectors: [
    new MetaMaskConnector({
      chains,
      shimDisconnect: true,
      shimChainChangedDisconnect: true
    }),
    new WalletConnectConnector({
      chains,
      shimDisconnect: true,
      shimChainChangedDisconnect: true,
      options: {
        projectId: "cb89ebb21cdccb2e1b591e189e27706a",
        version: "2"
      }
    })
  ],
  publicClient,
  webSocketPublicClient
});


const App = () => {
  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/dashboard", element: <Dashboard /> },
    { path: "/dashboardCheck/:addressparam", element: <DashboardCheck /> },
    { path: "/join-now", element: <JoinNow /> },
    { path: "/join-now/:id/:pos", element: <JoinNow /> },
    { path: "/UpdateAddress", element: <UpdateAddress /> },
    { path: "/collapse", element: <RegistrationNotification /> },
    { path: "/distribute", element: <Distribute /> },
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <WagmiConfig config={config}>
        <ToastContainer />
        <Router>
          <App />
        </Router>
      </WagmiConfig>
    </Provider>

  );
};

export default AppWrapper;
